import { useEffect, useState } from "react";
import Header from "../../headers/Header";


const row = {
    display: "flex"
}
const column = {
    flex: "50%",
    padding: "5px",
    height: "10px",
};

export default function Identification({ typeAnita }) {
    var verif = true;
    var [myInputs, setMyInputs] = useState([])
    useEffect(() => {

        typeAnita[1].map((x) => {
            let ligne = x.split(':')
            console.log(ligne)
        })

    }, [])

    return (<> <Header type={"client"} title={"Identification"} /><div className="stopwatch" >

        <br />
        <span style={{ width: "50%", marginLeft: 'auto', marginRight: 'auto' }}>
            <br />
            Editable Fields
            <div style={{ width: "100%", textAlign: 'left', marginLeft: '5%' }}>
                {typeAnita[1].map((x, index) => {
                    if (x === "Curing cycle Alarms and Events") {
                        verif = false;
                    }
                    if (x !== "" && index < 30 && verif) {

                        let ligne = x.split(':')
                        if (index === 0) {
                            return (<div style={row}> <div style={column} >{ligne[0]}</div> {ligne[1] !== " " && ligne[1] !== undefined ? <div style={column} >{ligne[1] !== "" ? ligne[1] : null}  {ligne[2] !== " " && ligne[2] !== undefined ? ":" : null} {ligne[2] !== "" ? ligne[2] : null}</div> : <div style={column} ></div>}  <br /></div>)
                        }
                        else {
                            if (ligne[1] !== " " && ligne[1] !== undefined) {
                                myInputs[index] = ligne[1]
                            }
                            if (ligne[2] !== "" && ligne[2] !== undefined) {
                                myInputs[index] += ':' + ligne[2]
                            }

                            return (<div style={row}>
                                <div style={column} >{ligne[0]}</div>

                                {ligne[1] !== "" && ligne[1] !== undefined ?

                                    <div style={column} >
                                        <input type="text" value={myInputs[index]} onChange={(event) => {
                                            console.log("we are changing " + typeAnita[1][index] + " " + event.target.value);
                                            typeAnita[1][index] = ligne[0] + ' : ' + event.target.value;
                                            myInputs[index] = event.target.value
                                        }}
                                        />
                                    </div> :

                                    <div style={column} >
                                        <input type="text" onChange={(event) => {
                                            console.log("we are changing " + typeAnita[1][index] + " " + event.target.value); typeAnita[1][index] = ligne[0] + ' : ' + event.target.value
                                        }} />
                                    </div>
                                }  <br />
                            </div>
                            )
                        }
                    }
                })}
                <br />  </div>
        </span></div>
    </>)
}